import { SET_PROJECTS_BY_ID, RESET_PROJECT_BY_ID } from "../../constants";

const initialState = {
  isProjectLoading: true,
};

export const projectById = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_PROJECTS_BY_ID:
      return { ...action.payload, isProjectLoading: false };

    case RESET_PROJECT_BY_ID:
      return initialState;
    default:
      return state;
  }
};
